jQuery(function($){

    $(".btn.bm-btn-customize").on("click", function(){
        const url = $(this).attr("data-url");
        const page = $(this).attr("data-page");
        // https://beyond-memories.com/products/3d-crystal-decor-mom?view=bm-product-customize
        const baseUrl = window.location.origin;

        window.location.href = `${baseUrl}${url}?view=${page}`
    })

});